import * as React from 'react';
export const IcLinkedin = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19.65 3H4.35A1.33 1.33 0 003 4.31v15.38A1.33 1.33 0 004.35 21h15.3A1.33 1.33 0 0021 19.69V4.31A1.33 1.33 0 0019.65 3zM8.33 18.34H5.7V9.79h2.63v8.55zM7.05 8.59A1.59 1.59 0 015.47 7a1.54 1.54 0 011.58-1.56 1.58 1.58 0 010 3.15zm11.4 9.67h-2.7v-4.2c0-1 0-2.32-1.42-2.32s-1.58 1.12-1.58 2.17v4.28h-2.63v-8.4h2.48v1.12h.07a3 3 0 012.55-1.42c2.7 0 3.23 1.8 3.23 4.12v4.65z'
      fill='currentColor'
    />
  </svg>
);
